export default "__VITE_ASSET__cAptp6QU__"